import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from './List';
import Details from './Details';
import {useCorporateActionsEvent} from "../../../api";


export default function LayoutSingle({id}) {
  const {isLoading, data: actionEvent} = useCorporateActionsEvent(id);

  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={7} lg={8}>
        {isLoading && (<span><CircularProgress size='1rem'/> Loading ...</span>)}
        {!isLoading && actionEvent?.id && <List corporateActions={[actionEvent]} expanded={actionEvent.id}/>}
      </Grid>
      <Grid item xs={12} md={5} lg={4}>
        <Details corporateAction={actionEvent} show={actionEvent?.id}/>
      </Grid>
    </Grid>
  );
}
